export const getBoolean = boolean => {
  return typeof boolean === "string"
    ? boolean === "true" || boolean === "Yes"
    : boolean;
};
